import { formatDate, formatRupiah } from "@/lib/format";
import { Check } from "lucide-react";

export const ScheduleDates = ({ s, testid }) => {
  const list = s.method === "split" ? s.tranches || [] : [];
  if (!list.length) return <span>{formatDate(s.payment_date)}</span>;
  return (
    <div className="flex flex-col gap-1" data-testid={testid}>
      {list.map((t, i) => (
        <div key={i} className="flex items-center gap-2 whitespace-nowrap" data-testid={`${testid}-${i + 1}`}>
          <span className={`inline-flex h-5 min-w-[38px] items-center justify-center rounded-full px-1.5 text-[11px] font-semibold ${t.cleared ? "bg-emerald-50 text-emerald-700" : "bg-zinc-100 text-slate-600"}`}>
            {t.cleared && <Check className="h-3 w-3 mr-0.5" />}BG {i + 1}
          </span>
          <span className={t.cleared ? "text-slate-400 line-through" : ""}>{formatDate(t.cair_date)}</span>
          <span className="text-[11px] text-slate-400">{formatRupiah(t.amount)}</span>
        </div>
      ))}
    </div>
  );
};
